<div class="transparency-holder">
  <div class="toggle-header" (click)="toggleContent()">
    <p><span class="icon-i-info"></span>{{ 'account.transparency.label.why' | translate }}</p>
    <span class="icon-i-chevron-down arrow" [ngClass]="{ active: active }"></span>
  </div>
  <div class="toggle-content" [ngClass]="{ active: active }">
    <p>{{ 'account.lifeSituation.dataWhy.p1' | translate }}</p>
    <p>{{ 'account.lifeSituation.dataWhy.p2' | translate }}</p>
  </div>
</div>
